import React from 'react';

import {Field, Form} from 'formik';

import Radium from 'radium';
import MUIButton from 'muicss/lib/react/button';
import Select from "react-select";

const errorStyle = {color: "rgb(250, 16, 0)", fontSize:"12px", display:"block", marginBottom:"10px"};

const InputField = Radium(({
		field, 
		form: { touched, errors }, 
		...props
	}) => {

	const label = props.label? <label>{props.label}</label>: '';

	let input = <input {...field} {...props} />;

	//by default its on
	if(props.mui !== "off")
		input = <div className="mui-textfield">{label}{input}</div>;

	return <span>
		{label !== '' && props.mui === "off" && label}
		{input}
		
	    {touched[field.name] && errors[field.name] && <span style={errorStyle}>{errors[field.name]}</span>}
	  </span>
});

const ComboBoxField = Radium(({
	field,
	form: {touched, errors, setFieldValue, setFieldTouched},
	...props
	}) => {
	const fieldName = field.name;

	const onFieldChange = opt => {
		let value = null;
		if(opt) {
			value = props.multi === true? opt.map(o => o.value): opt.value;
		} else {
			value = props.multi === true? []: '';
		}

		setFieldValue(fieldName, value);

		if(props.onComboChange && typeof props.onComboChange === 'function')
			props.onComboChange(value, setFieldValue);
	}
	
	const onFieldBlur = opt => {
		setFieldTouched(fieldName, true);
	}

	let containerStyle = [{ margin: '20px 0' }];

	if(props.style)
		containerStyle.push(props.style);

	const labelStyle = {color: 'rgba(0,0,0,.54)', fontSize: '12px', fontWeight: '400', lineHeight: '15px'};
	const label = props.label? <label style={labelStyle}>{props.label}</label>: '';

	const isCreatable = props.creatable && props.creatable === true;
	const isAsync = props.async && props.async === true;
	return <div style={containerStyle}>
				{label !== '' && label}

				{
					isCreatable && isAsync &&
					<Select.AsyncCreatable onChange={onFieldChange} onBlur={onFieldBlur} {...props} />		
				}

				{
					isCreatable && !isAsync &&
					<Select.Creatable onChange={onFieldChange} onBlur={onFieldBlur} {...props} />	
				}
				
				{
					!isCreatable && isAsync &&
					<Select.Async onChange={onFieldChange} onBlur={onFieldBlur} {...props} />	
				}

				{
					!isCreatable && !isAsync &&
					<Select onChange={onFieldChange} onBlur={onFieldBlur} {...props} />	
				}

		    	{touched[field.name] && errors[field.name] && <span style={errorStyle}>{errors[field.name]}</span>}

	      </div>
});

const TextAreaField = Radium(({
		field, 
		form: { touched, errors }, 
		...props
	}) => {

	const label = props.label? <span><label>{props.label}</label><br /><br /></span>: '';
	let input = <textarea {...field} {...props} />;
	
	if(props.mui !== "off")
		input = <div className="mui-textfield">{label}{input}</div>;

	return <span style={props.style}>
		{label !== '' && props.mui === "off" && label}
		{input}
	    {touched[field.name] && errors[field.name] && <span style={errorStyle}>{errors[field.name]}</span>}
	  </span>
});


const CheckBoxField = Radium(({
		field, 
		form: { touched, errors }, 
		...props
	}) => {
	
	return <span>
		<input {...props} id={field.name} type="checkbox" checked={field.value} onChange={(event) => {

			if(typeof props.onChange === 'function')
				props.onChange(event);
				
			field.onChange(event);
		}} />

        <label htmlFor={field.name} style={{cursor: 'pointer'}}> {props.label}</label>
        <br/>
	    {touched[field.name] && errors[field.name] && <span style={errorStyle}>{errors[field.name]}</span>}
	  </span>
});



const RadioField = Radium(({
		field, 
		form: { touched, errors }, 
		...props
	}) => {

	const label = props.label? props.label: '';

	let input = <input {...field} {...props} type="radio" />;

	//by default its on
	if(props.mui !== "off")
		input = <div className="mui-radio"><label>{input} {label}</label></div>;


	return <span style={props.style}>
		{input}
		{label !== '' && props.mui === "off" && <label> {label}</label>}
	    {touched[field.name] && errors[field.name] && <span style={errorStyle}>{errors[field.name]}</span>}
	  </span>
});

//Note: Don't pass array of styles. Radium does not work with MUIButton in older version of Firefox
export const SubmitButton = (props) => {
	return <MUIButton variant="raised" type="submit" {...props} disabled={props.disabled} />
};

export const Input = (props) => {
	return <Field {...props} component={InputField} />
};


export const TextArea = (props) => {
	return <Field {...props} component={TextAreaField} />
};

export const Checkbox = (props) => {
	
	return <Field {...props} component={CheckBoxField} />
};

export const RadioButton = (props) => {
	
	return <Field {...props} component={RadioField} />
};

export const ComboBox = (props) => {
	
	return <Field {...props} component={ComboBoxField} />	
}

export const RGForm = Radium((props) => {
	return <Form style={props.style}>{props.children}</Form>
});










// WEBPACK FOOTER //
// ./src/views/FormElements.js